import { ShopperAgentDiscountConfigSchema } from "@redotech/redo-model/shopper-agent/discount-config";
import * as z from "zod/v4";

export const updateShopperAgentDiscount = {
  name: "updateShopperAgentDiscount" as const,
  input: z.object({
    discountConfig: ShopperAgentDiscountConfigSchema.nullable(),
  }),
  output: z.object({ success: z.boolean() }),
};
